import { render, staticRenderFns } from "./TagsComponent.vue?vue&type=template&id=c7dce382&scoped=true"
import script from "./TagsComponent.vue?vue&type=script&lang=js"
export * from "./TagsComponent.vue?vue&type=script&lang=js"
import style0 from "./TagsComponent.vue?vue&type=style&index=0&id=c7dce382&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7dce382",
  null
  
)

export default component.exports